<app-cookie-popup></app-cookie-popup>
<app-navbar class="mat-elevation-z6"></app-navbar>
<router-outlet></router-outlet>
